module.exports = __webpack_public_path__ + "static/img/4.ce66574.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/4.png
// module id = 474
// module chunks = 1